import { useSmartrrFlags } from "@smartrr/shared/LaunchDarkly";
import { createLazyFileRoute, Navigate } from "@tanstack/react-router";
import { ErrorBoundary } from "@vendor-app/app/_sharedComponents/ErrorBoundary";
import { AdminGettingStartedRoute } from "@vendor-app/app/AdminRoute/AdminGettingStartedRoute";
import { AuthorizedRoute } from "@vendor-app/app/AdminRoute/components/authorization/AuthorizedRoute";
import { FeatureEnum } from "@smartrr/shared/entities/AccountPlan";

export const Route = createLazyFileRoute("/admin/getting-started")({
  component: Index,
  errorComponent: ({ error, info }) => <ErrorBoundary error={error} info={info} />,
});

function Index() {
  const { vendorPortalGettingStartedPage: gettingStartedFeatureFlagEnabled } = useSmartrrFlags();

  if (gettingStartedFeatureFlagEnabled === false) {
    return <Navigate to="/admin" />;
  }

  return AuthorizedRoute(FeatureEnum.CORE_SUBSCRIPTIONS, <AdminGettingStartedRoute />);
}
